import { ExternalUserServiceIntegration } from '../../models/User'
import { IntegrationServiceId } from '../../common/integrations'
import { IntegrationIcon } from '../../components/IntegrationIcon'

export const getConnectorIcon = (emailIntegration: ExternalUserServiceIntegration | null, size: number = 24) => {
  if (!emailIntegration) {
    return null
  }
  const { serviceId } = emailIntegration
  if (serviceId === IntegrationServiceId.GMAIL) {
    return <IntegrationIcon serviceId={IntegrationServiceId.GMAIL} width={size} height={size} />
  }
  if (serviceId === IntegrationServiceId.OUTLOOK_MAIL) {
    return <IntegrationIcon serviceId={IntegrationServiceId.OUTLOOK_MAIL} width={size} height={size} />
  }
  return null
}
